<div class="modal-header border-b">
  <h4 class="modal-title title">{{modelHeader}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body margin-td">
  <div class="card scrollbar">
    <div class="card-content">
      <div class="card-body">
        <div class="row">
          <!-- New Fields -->
          <div class="col-6">
            <div class="af-form-group">
              <label>{{'lblControllerName' | translate}} :</label>
              <div class="lbl-info">{{exceptionLog.controllerName}}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="af-form-group">
              <label>{{'lblMethodName' | translate}} :</label>
              <div class="lbl-info">{{exceptionLog.methodName}}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="af-form-group">
              <label>{{'lblMethodType' | translate}} :</label>
              <div class="lbl-info">{{exceptionLog.methodType}}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="af-form-group">
              <label>{{'lblDate' | translate}} :</label>
              <div class="lbl-info">{{exceptionLog.createdDate | date : 'short'}}</div>
            </div>
          </div>
          <div class="col-12">
            <div class="af-form-group">
              <label>{{'lblErrorMessage' | translate}} :</label>
              <div class="lbl-info" [ngStyle]="{ 'color': exceptionLog.exception ? 'inherit' : 'red' }">
                {{exceptionLog.exception || 'Error'}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="af-form-group">
              <label>{{'lblException' | translate}} :</label>
              <textarea class="form-control" readonly style="height:100px;">{{exceptionLog.errorMessage}}</textarea>
            </div>
          </div>
          <div class="col-12">
            <div class="af-form-group">
              <label>{{'lblStackTrace' | translate}} :</label>
              <textarea class="form-control" readonly style="height:400px;">{{exceptionLog.stackTrace}}</textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" aria-label="Center Align" (click)="activeModal.dismiss(false)"
    translate>lblClose</button>
</div>